import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import IdentifierDialog from './IdentifierDialog';
import { globalStyles } from './style/gstheme';

const styles = Object.assign({}, globalStyles);

class IRI extends React.PureComponent {

    render() {

        const { classes, label, dataTest, placeholder, isReadOnly, graph, baseIRI, currentIRI, onUpdateIRI, onDelete } = this.props;

        const styleClass = isReadOnly ? classes.basicReadField : classes.inputLabel;

        return (
            <React.Fragment>
                <TextField
                    margin="dense"
                    name="version-iri"
                    value={currentIRI || placeholder}
                    variant="outlined"
                    label={label}
                    fullWidth={true}
                    style={{ marginTop: '0px' }}
                    InputProps={{
                        inputProps: {
                            "data-test": dataTest
                        },
                        className: styleClass,
                        classes: {
                            input: styleClass
                        },
                        readOnly: true,
                        endAdornment: <InputAdornment position="end">
                            {!isReadOnly &&
                                <React.Fragment>
                                    <span style={{ marginRight: 2 }}>
                                        <IdentifierDialog
                                            showFolding={false}
                                            changeIRI={onUpdateIRI}
                                            currentIRI={currentIRI}
                                            graph={graph}
                                            baseIRI={baseIRI} />
                                    </span>
                                    {currentIRI &&
                                        <Tooltip title="Delete IRI" className={classes.smallIconButton}>
                                            <IconButton data-test={dataTest + "-delete"} onClick={onDelete} size="small">
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </React.Fragment>
                            }
                        </InputAdornment>

                    }
                    } />
            </React.Fragment>
        );
    }
}

IRI.defaultProps = {
    fullWidth: false,
    isReadOnly: false,
    placeholder: "No IRI has been set."
};

IRI.propTypes = {
    placeholder: PropTypes.string,
    currentIRI: PropTypes.string,
    graph: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    isReadOnly: PropTypes.bool,
    project: PropTypes.string,
    onUpdateIRI: PropTypes.func.isRequired,
    baseIRI: PropTypes.string,
    dataTest: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(IRI));